import {api} from '../../contexts/AuthContext';

export const mediaPlanningApi = {
    getOverview: async (promptId?: string) => {
        const response = await api.get('/api/media-planning/overview', {
            params: promptId ? {promptId} : undefined,
        });
        return response.data;
    },
    getDimensions: async (promptId?: string, filters?: Record<string, string>) => {
        const params: Record<string, string> = {...filters};
        if (promptId) params.promptId = promptId;
        const response = await api.get('/api/media-planning/dimensions', {params});
        return response.data;
    },
    getInsights: async (promptId?: string, filters?: Record<string, string>) => {
        const params: Record<string, string> = {...filters};
        if (promptId) params.promptId = promptId;
        const response = await api.get('/api/media-planning/insights', {params});
        return response.data;
    },
    getRecommendations: async (context: any) => {
        const response = await api.post('/api/media-planning/recommendations', context);
        return response.data;
    },
    getComparison: async (promptIds: string[]) => {
        const response = await api.get('/api/media-planning/compare', {
            params: {promptIds: promptIds.join(',')},
        });
        return response.data;
    },
    getTrends: async (promptId: string, days?: number) => {
        const response = await api.get('/api/media-planning/trends', {
            params: {promptId, days},
        });
        return response.data;
    },
};
